import ValidationError from "../../shared/domain/exceptions/ValidationError";
import ValueObject from "../../shared/domain/ValueObject";
import { RuleTypeLiteral } from "./RuleValue";

export class RuleType<TRuleType extends RuleTypeLiteral = RuleTypeLiteral> extends ValueObject<TRuleType> {
    constructor(value: TRuleType) {
        if (!Object.values(RuleTypeEnum).includes(value as unknown as RuleTypeEnum)) {
            throw new ValidationError(`Invalid rule type: ${value}`);
        }
        super(value);
    }
}

export enum RuleTypeEnum {
    YOUTUBE_TOPIC = "youtubeTopic",
    YOUTUBE_VIDEO = "youtubeVideo",
    YOUTUBE_CHANNEL = "youtubeChannel",
    WEB_CATEGORY = "webCategory",
    WEB_HOSTNAME = "webHostname",
    WEB_URL = "webUrl",
}
